import React from 'react';
import { useTranslation } from 'react-i18next';
import useCreateTitle from './useCreateTitle';
import SaleFeesPanel from '../components/Sales/SaleFeesPanel';
import DrawerBody from './DrawerBody';
import { IcoLn } from './ActionIcons';
import DrawerHeader from './drawer/DrawerHeader';

// Shell host only: the existing sale-fee surface retains its validation, posting, and single-flight
// behavior; this component supplies the standard CreateDrawerHost chrome around it.
export default function SaleFeesCreateForm({ size, onSize, onClose, onInteract, params }) {
  const { t } = useTranslation('dataEntry');
  const ct = useCreateTitle();
  return (
    <>
      <DrawerHeader eyebrow={t('dataEntry:fl.sales_fees')} ini={<IcoLn name="add" />} title={<>{ct('sale-fees')}</>} size={size} onSize={onSize} onClose={onClose} />
      <DrawerBody onClose={onClose}>
        <SaleFeesPanel partnerId={params?.partner_id || ''} partnerName={params?.partner_name || ''} initialOpId={params?.operationId || ''} lockOrder={!!params?.operationId} feeId={params?.feeId || ''} disposition={params?.disposition || ''} onCancel={onClose} onPosted={() => {
          window.dispatchEvent(new Event('sales-entry-posted'));
          if (onInteract) onInteract(false);   // fb-177: posted -> nothing left in progress
        }} />
      </DrawerBody>
    </>
  );
}
